import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { purchaseCoinWithCreditApi } from '@!/Api/coinPurchase'

export const usePaymentExecPurchase = () => {
  const [apiError, setApiError] = useState({ error: null, errorInfo: null })

  const execPurchaseMutation = useMutation({
    mutationFn: ({ listIndex, apiTime }) => purchaseCoinWithCreditApi({ listIndex: listIndex, apiTime: apiTime }),
    onError: (error) => {
      if (error.data?.error) {
        const errorInfo = error.data?.ErrInfo ? error.data.ErrInfo : null
        setApiError({ error: error.data.error, errorInfo: errorInfo })
      } else {
        setApiError({ error: 'etc_error' })
      }
    },
  })

  return [execPurchaseMutation, apiError]
}
